import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const assignAccountsEntitlementsSlice = getBulkActionSlice(
    'assignAccountsEntitlementsResult',
);

export const selectAssignAccountsEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.assignAccountsEntitlementsResult.shown;

export const selectAssignAccountsEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.assignAccountsEntitlementsResult.uuid;

export const selectAssignAccountsEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.assignAccountsEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = assignAccountsEntitlementsSlice.actions;
